import { Box } from '@mui/material';
import { KeyboardDoubleArrowDown as ArrowIcon } from '@mui/icons-material';

function MovingArrows() {
    return (
        <Box>
            {[0, 0.5, 1].map((delay) => (
                <ArrowIcon
                    color="primary"
                    key={delay}
                    sx={{
                        fontSize: 50,
                        animation: `moveArrow 1.5s infinite`,
                        animationDelay: `${delay}s`,
                    }}
                />
            ))}
        </Box>
    );
}

export default MovingArrows;

// Ajoute cette règle CSS pour l'animation de déplacement des flèches
const movingStyles = `
@keyframes moveArrow {
  0% { transform: translateX(0); opacity: 0.5; }
  50% { transform: translateY(3px); opacity: 1; }
  100% { transform: translateX(0); opacity: 0.5; }
}
`;

document.head.insertAdjacentHTML("beforeend", `<style>${movingStyles}</style>`);
